<div class="fulfillmentLanding xs-mt-0 xs-mb-40">
  <div class="status-bar">
    {{bannerMessage}}
  </div>
</div>
<div class="fulfillmentLanding container-return-wrapper">
  <div class="containerReturnsLandingPage">
    <div class="row">
      <div class="col-md-12 col-lg-12 margin-l0 TopSec">
        <h3>
          Container Returns
        </h3>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-11 col-md-9 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div class="col-lg-1 col-md-3 margin-t12 text-left">
        <button mat-raised-button class="btns xs-button xs-full-width export-button" [disabled]="(this.selectedTabIndex === 0 && this.returnRequestList && this.returnRequestList.length <= 0) || (this.selectedTabIndex === 1 && this.returnRequestDraftList && this.returnRequestDraftList.length <= 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Active Container Return Request
                </h4>
                <p class="subhead">
                  Add/Manage products for return.
                </p>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-4">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #returnRequestPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                  <button *ngIf="!readOnlyAccess" mat-raised-button class="btns margin-l5 index-z200" color="primary" (click)="createNewReturn()">New Return</button>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #returnRequestTable [dataSource]="returnRequestDataSource" matSort #returnRequestSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="returnRequestNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Return ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="navigateOrderDetail(element,'active')">
                      <u>
                        <p class="accNo">
                          {{element.returnRequestNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info defaultCursor">
                    <div class="order-info">
                      <p class="accName">
                        {{element.accountName}}
                      </p>
                      <p> {{element.accountAddress1}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Account#</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="purchaseOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customerPO  text-center">Customer PO#</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.purchaseOrderNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="orderCreateDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Request Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderCreateDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="status text-center"> Status </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span class="statusMsg">
                      {{getStatusText(element.status)}}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="contextMenu">
                  <th mat-header-cell *matHeaderCellDef class="actionBtn">&nbsp;</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div>
                      <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                        <button mat-menu-item (click)="viewOrderToInvoice(element)">View Return Order</button>
                      </mat-menu>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef class="xs-none">  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="returnRequestColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: returnRequestColumns;"></tr>
              </table>
              <div *ngIf="returnRequestList == undefined || returnRequestList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

          <mat-tab>
            <div class="col-md-2">
              <ng-template mat-tab-label>
                <i class="icon-ico-grower_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
                <div class="tab-head">
                  <h4>
                    Draft Container Return Request
                  </h4>
                  <p class="subhead">
                    Finish your draft to submit the request.
                  </p>
                </div>
              </ng-template>
            </div>

            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10">
                  <div class="display-ib wAuto">
                    <mat-paginator #returnRequestDraftPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>

            <div class="tableContainer draftReturnRequest">
              <table mat-table #returnRequestDraftTable [dataSource]="draftRequestDataSource" matSort #returnRequestDraftSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="returnRequestNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Return ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="navigateOrderDetail(element,'draft')">
                      <u>
                        <p class="accNo">
                          {{element.returnRequestNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountName">

                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info">
                    <div class="order-info">
                      <p class="accName">
                        {{element.accountName}}
                      </p>
                      <p> {{element.accountAddress1}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Account#</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="purchaseOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customerPO text-center">Customer PO#</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.purchaseOrderNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="orderCreateDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Draft Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderCreateDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="contextMenu">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="actionBtn">Delete</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <i *ngIf="!readOnlyAccess" title="delete" class="pr-3 icon-ico-trash handCursor" (click)="deleteOrder(element)"></i>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="returnRequestDraftColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: returnRequestDraftColumns;"></tr>
              </table>
              <div *ngIf="returnRequestDraftList == undefined || returnRequestDraftList.length == 0" class="noDataMsg draftOrderHeight">
                <p>No Record Found.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
